import { CircularProgress, Dialog, DialogContent } from '@mui/material';
import { DeleteOutline as DeleteIcon } from '@mui/icons-material';
import GlobalButton, {
  GlobalButtonVariant,
} from '@/components/buttons/GlobalButton';

interface DeleteConfirmModalProps {
  open: boolean;
  title: string;
  description: React.ReactNode;
  confirmLabel?: string;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteConfirmModal = ({
  open,
  title,
  description,
  confirmLabel = 'Eliminar',
  isLoading,
  onClose,
  onConfirm,
}: DeleteConfirmModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={isLoading ? undefined : onClose}
      maxWidth='xs'
      fullWidth
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(15, 23, 42, 0.45)',
            backdropFilter: 'blur(6px)',
          },
        },
        paper: {
          sx: {
            borderRadius: 4,
            overflow: 'hidden',
            boxShadow: '0 24px 80px rgba(15, 23, 42, 0.28)',
          },
        },
      }}
    >
      <div className='h-1.5 w-full bg-red-600' />

      <DialogContent sx={{ px: 4, pt: 4, pb: 3.5 }}>
        <div className='flex flex-col items-center text-center gap-4'>
          <span className='flex items-center justify-center w-16 h-16 rounded-full bg-red-600/10 ring-8 ring-red-600/5'>
            <DeleteIcon sx={{ fontSize: 32, color: 'error.main' }} />
          </span>

          <div className='flex flex-col gap-1.5'>
            <h2 className='text-xl font-bold text-gray-900 m-0'>{title}</h2>
            <p className='text-[15px] leading-relaxed text-gray-500 m-0'>
              {description}
            </p>
          </div>

          <div className='flex w-full gap-2.5 pt-1'>
            <GlobalButton
              variant={GlobalButtonVariant.secondaryButton}
              action={onClose}
              disabled={isLoading}
              className='flex-1'
            >
              Cancelar
            </GlobalButton>
            <GlobalButton
              variant={GlobalButtonVariant.primaryButton}
              action={onConfirm}
              disabled={isLoading}
              className='flex-1'
              sx={{
                bgcolor: 'error.main',
                '&:hover': { bgcolor: 'error.dark' },
              }}
            >
              {isLoading ? (
                <CircularProgress size={18} color='inherit' />
              ) : (
                <DeleteIcon fontSize='small' />
              )}
              {isLoading ? 'Eliminando...' : confirmLabel}
            </GlobalButton>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteConfirmModal;
